import {
	Card,
	formatter,
	useLanguageResource,
} from "@ruter-as/web-components-and-tools";
import type React from "react";
import CarIllustration from "../../gfx/carIllustration";
import getSubscriptionText from "../../subscriptionText";
import { useAuthenticatedAuthContext } from "../auth/Auth.component";
import "./Confirmation.scss";
import { CyclingMedium, ValidTicket } from "@ds/illustrations";
import confirmationLanguageResource from "./lang-resource";

export interface ConfirmationProps {
	showJoule: boolean;
	showCompanyTicket: boolean;
	showCarRental: boolean;
	carPoolSmsDate: Date | undefined;
}

const Confirmation: React.FC<ConfirmationProps> = ({
	showJoule,
	showCompanyTicket,
	showCarRental,
	carPoolSmsDate,
}) => {
	const lang = useLanguageResource(confirmationLanguageResource);
	const { selectedCompany } = useAuthenticatedAuthContext();

	return (
		<div className="confirmation-page" data-test-id="confirmation-page">
			<h1>{lang.title}</h1>
			<h2>Hva skjer nå?</h2>
			{(showCompanyTicket || selectedCompany.hasTravelSubscription) && (
				<Card variant="horizontal" className="card">
					<Card.Content className="card-content">
						<Card.Title>Månedsbillett</Card.Title>
						{selectedCompany.widgetPolicy === "request" && (
							<Card.Paragraph>{lang.ticketRequestText}</Card.Paragraph>
						)}
						{selectedCompany.widgetPolicy === "create" && (
							<Card.Paragraph>
								{getSubscriptionText(
									lang.ticketCreateText,
									selectedCompany.subTypeId === "HOUSING_COOPERATIVE_AGREEMENT",
								)}
							</Card.Paragraph>
						)}
					</Card.Content>
					<Card.Illustration className="illustration">
						<ValidTicket />
					</Card.Illustration>
				</Card>
			)}
			{showJoule && (
				<Card variant="horizontal" className="card">
					<Card.Content className="card-content">
						<Card.Title>Elsykkel</Card.Title>
						<Card.Paragraph>
							En sms med rabattkode er sendt til ditt mobilnummer. Fortsett
							bestillingen hos{" "}
							<a
								href="https://joule.no/pages/ruterxjoule"
								target="_blank"
								rel="noreferrer"
							>
								https://joule.no/pages/ruterxjoule
							</a>{" "}
							og bruk rabattkoden i utsjekksprosessen.
						</Card.Paragraph>
					</Card.Content>
					<Card.Illustration className="illustration">
						<CyclingMedium />
					</Card.Illustration>
				</Card>
			)}
			{(showCarRental || selectedCompany.hasTravelSubscription) && (
				<Card variant="horizontal" className="card">
					<Card.Content className="card-content">
						<Card.Title>Leiebil</Card.Title>
						<Card.Paragraph>
							{carPoolSmsDate
								? `SMS med 200 kr rabattkode sendes ved oppstart av abonnementet (${formatter.date.toShortDateString(carPoolSmsDate)}). Ikke del lenken med uvedkommende, de vil kunne bruke din kode. Koden kan benyttes hos Hyre, Bilkollektivet og Getaround`
								: "En SMS med 200 kr rabattkode er sendt til ditt mobilnummer (Ikke del lenken med uvedkommende, de vil kunne bruke din kode). Kodene kan benyttes hos Hyre, Bilkollektivet og Getaround"}
						</Card.Paragraph>
						<ul>
							<li>
								<Card.Paragraph>
									Når du ønsker å bestille en bil, velger du aktør og henter ut
									rabattkoden din
								</Card.Paragraph>
							</li>
							<li>
								<Card.Paragraph>
									Når du gjør dette, nullstilles oppspart rabatt. Dersom du ikke
									henter ut koden den første måneden vil oppspart rabatt økes
									til 400 kr. Maks oppspart rabatt er 600 kr.
								</Card.Paragraph>
							</li>
							<li>
								<Card.Paragraph>
									Du vil få en SMS med ny lenke månedlig.
								</Card.Paragraph>
							</li>
						</ul>
					</Card.Content>
					<Card.Illustration className="illustration">
						<CarIllustration />
					</Card.Illustration>
				</Card>
			)}
		</div>
	);
};

export default Confirmation;
